

























import {Advisor, Component, ComponentStyle, ComponentStyleDefinition, SortDirection, Vue} from "@zoovu/runner-browser-api";
import { directive as clickOutside } from "v-click-outside";

@Component({
    directives: {
        clickOutside
    }
})
export default class SortView extends Vue {
    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    isOpened: boolean = false;

    sortItems: SortBy[] = [{
        sortAttribute: null,
        sortDirection: null,
        sortLabelKey: "message-sort-not-specified"
    }, {
        sortAttribute: "price",
        sortDirection: SortDirection.ASCENDING,
        sortLabelKey: "message-sort-price-ascending"
    }, {
        sortAttribute: "price",
        sortDirection: SortDirection.DESCENDING,
        sortLabelKey: "message-sort-price-descending"
    }];

    get advisor(): Advisor {
        return this.$root["componentViewModel"];
    }

    get clickOutsideConfig() {
        return {
            handler: () => this.isOpened = false,
            isActive: this.isOpened
        }
    }

    get selectedValue() {
        const userSelections = this.advisor.userSelections;
        if (userSelections != null) {
            const sortItem = this.sortItems
                .find((sortItem) => sortItem.sortDirection === userSelections.sortDirection && sortItem.sortAttribute === userSelections.sortBy);
            return sortItem != null ? sortItem : sortItem[0];
        } else {
            return this.sortItems[0];
        }
    }

    select(index: number) {
        const sortItem = this.sortItems[index];
        if (this.advisor.userSelections != null) {
            this.advisor.userSelections.setSort(sortItem.sortAttribute, sortItem.sortDirection);
        }
        this.isOpened = false;
    }

    toggle() {
        this.isOpened = !this.isOpened;
    }
}

interface SortBy {
    sortAttribute: string;
    sortDirection: SortDirection;
    sortLabelKey: string;
}
